import React from 'react';
import { Button } from '@trello/nachos';
import { forNamespace } from 'app/common/lib/util/i18n';
import { useDismissTeamOnboardingMutation } from '@trello/graphql/generated';
import { Spinner } from 'app/src/components/Spinner';
import { navigate } from 'app/scripts/controller/navigate';
import styles from './TeamOnboardingMenu.less';

const format = forNamespace(['team onboarding', 'manage']);

interface TeamOnboardingMenuProps {
  orgId: string;
}

export const TeamOnboardingMenu: React.FC<TeamOnboardingMenuProps> = ({
  orgId,
}) => {
  const [
    dismissTeamOnboarding,
    { loading: isDismissing },
  ] = useDismissTeamOnboardingMutation();
  const onDismiss = async () => {
    await dismissTeamOnboarding({
      variables: {
        memberId: 'me',
        messageId: `bc-onboarding-home:${orgId}`,
      },
    });
    navigate(`/${location.pathname.split('/')[1]}/home`, {
      trigger: true,
    });
  };

  return (
    <div className={styles.container}>
      <strong>{format('title')}</strong>
      <p>{format('description')}</p>
      <Button
        appearance="default"
        className={styles.submitButton}
        onClick={onDismiss}
        isDisabled={isDismissing}
      >
        {isDismissing ? <Spinner centered small /> : format('hide')}
      </Button>
    </div>
  );
};
